import { render, staticRenderFns } from "./MusteriCekleri.vue?vue&type=template&id=4b8c2ba4&scoped=true"
import script from "./MusteriCekleri.vue?vue&type=script&lang=js"
export * from "./MusteriCekleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c2ba4",
  null
  
)

export default component.exports